import Vue from "vue";
import "./filters";
import App from "./App.vue";
import VueApollo from "vue-apollo";
import store from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSyncAlt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faInfoCircle,
  faArrowRight,
  faArrowLeft,
  faStar as fasStar
} from "@fortawesome/free-solid-svg-icons"; // Solid icons
import {
  faStar as farStar,
  faCheckCircle as farCheckCircle
} from "@fortawesome/free-regular-svg-icons"; // Outline icons
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { apolloClient } from "./clients/apollo";

library.add(
  faSyncAlt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faInfoCircle,
  farCheckCircle,
  faArrowRight,
  faArrowLeft,
  fasStar,
  farStar
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

const apolloProvider: VueApollo = new VueApollo({
  defaultClient: apolloClient
});

Vue.use(VueApollo);

new Vue({
  store,
  apolloProvider,
  render(createElement) {
    return createElement(App, {
      props: {
        productFinderId: this.$el.attributes.getNamedItem("initProfi")?.value
      }
    });
  }
}).$mount("#app");
